import pkg from "./pkg";
import { injectScript, logDebug } from "./util";

declare global {
  interface Window {
    dataLayer?: Array<unknown>;
  }
}

export const GOOGLE_TAG_GATEWAY_SCRIPT_ID = "os-google-tag-gateway";

export function getGoogleTagGatewaySrc(): string | null {
  if (!pkg.googleTagGateway) {
    return null;
  }

  const { containerId, path } = pkg.googleTagGateway;

  return `${path}/?id=${encodeURIComponent(containerId)}`;
}

/*
 * Segment's Google Tag Manager destination still loads the container from
 * googletagmanager.com. GTM only initializes a container ID once, so whichever
 * copy executes first runs the tags.
 *
 * Don't push the `gtm.js` start event here: the Segment destination pushes it,
 * and a second one would fire All Pages triggers twice.
 */
export function loadGoogleTagGateway() {
  const src = getGoogleTagGatewaySrc();

  if (!src) {
    return;
  }

  window.dataLayer = window.dataLayer || [];

  injectScript(GOOGLE_TAG_GATEWAY_SCRIPT_ID, src).catch(error => {
    logDebug("Google tag gateway failed to load:", error);
  });
}
